import { render, staticRenderFns } from "./PopupWindow.vue?vue&type=template&id=be205902&scoped=true&"
import script from "./PopupWindow.vue?vue&type=script&lang=js&"
export * from "./PopupWindow.vue?vue&type=script&lang=js&"
import style0 from "./PopupWindow.vue?vue&type=style&index=0&id=be205902&prod&scoped=true&lang=scss&"
import style1 from "./PopupWindow.vue?vue&type=style&index=1&id=be205902&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be205902",
  null
  
)

export default component.exports